export default "__VITE_ASSET__880acae0__"